import Global from './global';
import Order from './order';

export const Globals = Global;
export const Orders = Order;


// WEBPACK FOOTER //
// ./src/mixins/index.js